// Shared lightweight modal shell extracted from ConversationsV2Page.jsx
// (iter131). Owns just the centered card chrome + close icon — the
// actual close-button icon stays here as `DotsThreeVertical` per the
// legacy design.
import { DotsThreeVertical } from "@phosphor-icons/react";

export default function Modal({ title, children, onClose, testId }) {
  return (
    <div
      data-testid={testId}
      className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="bg-white rounded-sm shadow-xl border border-slate-200 w-full max-w-md p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-black tracking-tight">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700">
            <DotsThreeVertical size={16} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
